import React from 'react';
import { Database, Save } from 'lucide-react';

interface SystemConfig {
  domain: string;
  invalidTokenRedirect: string;
  tokenPrefix: string;
}

interface SystemConfigSectionProps {
  systemConfig: SystemConfig;
  setSystemConfig: React.Dispatch<React.SetStateAction<SystemConfig>>;
  onSave?: () => void;
}

const SystemConfigSection: React.FC<SystemConfigSectionProps> = ({ 
  systemConfig, 
  setSystemConfig,
  onSave
}) => {
  const handleSave = () => {
    if (onSave) onSave();
  };

  return (
    <div className="bg-white rounded-lg shadow mb-8">
      <div className="p-6">
        <h2 className="text-xl font-semibold mb-4 flex items-center">
          <Database className="mr-2" /> Configuration du système
        </h2>
        <div className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">Nom du domaine</label>
            <input
              type="text"
              value={systemConfig.domain}
              onChange={e => setSystemConfig({ ...systemConfig, domain: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Redirection si token invalide</label>
            <input
              type="text"
              value={systemConfig.invalidTokenRedirect}
              onChange={e => setSystemConfig({ ...systemConfig, invalidTokenRedirect: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">Préfixe des URLs tokenisées</label>
            <input
              type="text"
              value={systemConfig.tokenPrefix}
              onChange={e => setSystemConfig({ ...systemConfig, tokenPrefix: e.target.value })}
              className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-blue-500 focus:ring-blue-500"
            />
          </div>
          <button 
            className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 flex items-center"
            onClick={handleSave}
          >
            <Save className="mr-2" size={18} />
            Sauvegarder les paramètres
          </button>
        </div>
      </div>
    </div>
  );
};

export default SystemConfigSection;
export type { SystemConfig };
